import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";
import type { contractData } from "../types/uploadContract";

export const fetchContractById = async (id: number): Promise<ApiResponse<contractData>> => {
  return await apiClient<ApiResponse<contractData>>(`/v1/contract/${id}`);
};
